import React, { useState } from 'react';
import { Outlet, Link, useLocation } from 'react-router-dom';
import { FaHome, FaBook, FaCalendar, FaEnvelope, FaCog, FaChartLine, FaBars } from 'react-icons/fa';

const SidebarItem = ({ icon: Icon, label, to, active }) => (
    <Link
        to={to}
        style={{
            display: 'flex',
            alignItems: 'center',
            gap: '1rem',
            padding: '1rem',
            color: active ? 'var(--color-primary)' : 'var(--color-text-light)',
            background: active ? 'var(--color-surface)' : 'transparent',
            borderRadius: '8px',
            marginBottom: '0.5rem',
            fontWeight: active ? '600' : 'normal',
            transition: 'all 0.2s'
        }}
    >
        <Icon size={20} />
        <span>{label}</span>
    </Link>
);

const DashboardLayout = () => {
    const location = useLocation();
    const [sidebarOpen, setSidebarOpen] = useState(true);

    const menuItems = [
        { icon: FaHome, label: 'Overview', to: '/dashboard' },
        { icon: FaChartLine, label: 'My Progress', to: '/dashboard/progress' },
        { icon: FaBook, label: 'Courses', to: '/dashboard/courses' },
        { icon: FaCalendar, label: 'Calendar', to: '/dashboard/calendar' },
        { icon: FaEnvelope, label: 'Messages', to: '/dashboard/messages' },
        { icon: FaCog, label: 'Settings', to: '/dashboard/settings' },
    ];

    return (
        <div style={{ display: 'flex', minHeight: '100vh', background: '#f8f9fa' }}>
            {/* Sidebar */}
            <aside style={{
                width: sidebarOpen ? '260px' : '0',
                background: 'white',
                borderRight: '1px solid #eee',
                padding: sidebarOpen ? '1.5rem' : '0',
                overflow: 'hidden',
                transition: 'all 0.3s ease',
                display: 'flex',
                flexDirection: 'column'
            }}>
                <div style={{ marginBottom: '2rem', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                    <div style={{ width: '32px', height: '32px', background: 'var(--color-primary)', borderRadius: '50%' }}></div>
                    <span style={{ fontWeight: '700', fontSize: '1.2rem', color: 'var(--color-secondary)' }}>Synapse</span>
                </div>

                <nav style={{ flex: 1 }}>
                    {menuItems.map((item) => (
                        <SidebarItem
                            key={item.to}
                            {...item}
                            active={location.pathname === item.to}
                        />
                    ))}
                </nav>

                <div style={{ marginTop: 'auto', paddingTop: '1rem', borderTop: '1px solid #eee' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
                        <div style={{ width: '40px', height: '40px', borderRadius: '50%', background: '#eee' }}></div>
                        <div>
                            <div style={{ fontWeight: '600', fontSize: '0.9rem' }}>Student Name</div>
                            <div style={{ fontSize: '0.8rem', color: '#666' }}>student@synapse.com</div>
                        </div>
                    </div>
                </div>
            </aside>

            {/* Main Content */}
            <div style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
                <header style={{
                    height: '64px',
                    background: 'white',
                    borderBottom: '1px solid #eee',
                    display: 'flex',
                    alignItems: 'center',
                    padding: '0 2rem',
                    justifyContent: 'space-between'
                }}>
                    <button onClick={() => setSidebarOpen(!sidebarOpen)} style={{ background: 'none', border: 'none', cursor: 'pointer' }}>
                        <FaBars size={20} color="var(--color-secondary)" />
                    </button>
                    <div style={{ display: 'flex', gap: '1rem', alignItems: 'center' }}>
                        <button className="button-primary-yellow" style={{ padding: '0.5rem 1rem', fontSize: '0.9rem' }}>+ New Booking</button>
                    </div>
                </header>
                <main style={{ flex: 1, padding: '2rem', overflowY: 'auto' }}>
                    <Outlet />
                </main>
            </div>
        </div>
    );
};

export default DashboardLayout;
